import { writable } from 'svelte/store';
export const ROWS = writable(10);
export const COLS = writable(6);
export const SymType = writable('Horizontal');
